var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 500,
    zoomAndPan: "magnify",
    viewBox: "0 0 375 374.999991",
    height: 500,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "d3fb9a7125"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 9.445312 9.445312 L 365.695312 9.445312 L 365.695312 365.695312 L 9.445312 365.695312 Z M 9.445312 9.445312 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d3fb9a7125)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffbd59",
    d: "M 187.496094 9.445312 C 89.566406 9.445312 9.445312 89.566406 9.445312 187.496094 C 9.445312 285.421875 89.566406 365.542969 187.496094 365.542969 C 285.421875 365.542969 365.542969 285.421875 365.542969 187.496094 C 365.542969 89.566406 285.421875 9.445312 187.496094 9.445312 Z M 253.371094 182.152344 L 199.957031 235.566406 C 196.398438 239.128906 192.835938 240.910156 187.496094 240.910156 C 182.152344 240.910156 178.59375 239.128906 175.03125 235.566406 L 121.617188 182.152344 C 114.496094 175.03125 114.496094 164.347656 121.617188 157.226562 C 128.738281 150.105469 139.421875 150.105469 146.542969 157.226562 L 187.496094 198.175781 L 228.445312 157.226562 C 235.566406 150.105469 246.25 150.105469 253.371094 157.226562 C 260.496094 164.347656 260.496094 175.03125 253.371094 182.152344 Z M 253.371094 182.152344 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropDown);
export default __webpack_public_path__ + "static/media/dropDown.b3840e0475c8605d2b351b296f7ddc6f.svg";
export { ForwardRef as ReactComponent };